import React from "react";

const ReportCard = ({ title, children }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
      {title && (
        <h2 className="text-xl font-bold text-gray-900 mb-4">
          {title}
        </h2>
      )}
      {children}
    </div>
  );
};

export default ReportCard;
